import { getEOtherIncomeTypeSelectableList } from '@if/core/types'
import { ControlledNumberField, ControlledSelect, ControlledTextField, useTranslatedOptionEnum } from '@if/mui'
import DeleteIcon from '@mui/icons-material/Delete'
import { Box, IconButton, Stack, Tooltip } from '@mui/material'
import { Control, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formControl: Control<any>
  name: string
  onDeleteClicked: () => void
  disableEdit: boolean
  toolTip: string
}

const OtherIncomeComponent = ({ name, onDeleteClicked, formControl, disableEdit, toolTip }: Props) => {
  const { t } = useTranslation()
  const typeId: number = +useWatch({
    control: formControl,
    name: `${name}.typeId`,
  })
  const otherIncomeOptions = useTranslatedOptionEnum('EOtherIncomeType', getEOtherIncomeTypeSelectableList(), 'enum')

  return (
    <Stack direction="row" spacing={1} alignItems="start">
      <Tooltip title={toolTip}>
        <ControlledSelect
          name={`${name}.typeId`}
          control={formControl}
          label={t('editCreditApplication.income.other.typeId')}
          options={otherIncomeOptions}
          disabled={onDeleteClicked === undefined || disableEdit}
          disableEmptyOption
          fullWidth
        />
      </Tooltip>
      {typeId === 6 && (
        <Tooltip title={toolTip}>
          <ControlledTextField
            name={`${name}.description`}
            control={formControl}
            label="Description"
            disabled={onDeleteClicked === undefined || disableEdit}
            slotProps={{ htmlInput: { maxLength: 50 } }}
            fullWidth
          />
        </Tooltip>
      )}
      <Tooltip title={toolTip}>
        <ControlledNumberField
          name={`${name}.annualAmount`}
          control={formControl}
          label={t('editCreditApplication.income.other.annualAmount')}
          disabled={onDeleteClicked === undefined || disableEdit}
          disableDecimals
          fullWidth
          isMoney
        />
      </Tooltip>
      <Box>
        <IconButton
          id="otherIncomeDelete"
          aria-label="delete"
          color="error"
          sx={{ mt: 1 }}
          onClick={onDeleteClicked}
          disabled={disableEdit}
        >
          <DeleteIcon />
        </IconButton>
      </Box>
    </Stack>
  )
}

export default OtherIncomeComponent
